/**
 * Handles checkbox groups with an exclusive option (e.g., "Other/ Unsure").
 * When the exclusive checkbox is selected, all other checkboxes in the group are unchecked.
 * When any other checkbox is selected, the exclusive checkbox is unchecked.
 *
 * Uses event delegation to attach a single change listener per checkbox group.
 *
 * @param {string} exclusiveOptionAttribute - Attribute used to identify the exclusive checkbox (defaults to 'data-exclusive-option').
 * @returns {void}
 */
export default function handleCheckboxExclusiveOption(exclusiveOptionAttribute = 'data-exclusive-option') {
	document.querySelectorAll('.checkbox--group').forEach(group => {
		const checkboxes = [...group.querySelectorAll('input[type="checkbox"]')];
		const exclusiveOption = checkboxes.find(cb => cb.hasAttribute(exclusiveOptionAttribute));

		if (!exclusiveOption) {
			return;
		}

		group.addEventListener('change', (e) => {
			const cb = e.target;

			if (!checkboxes.includes(cb)) {
				return;
			}

			if (cb === exclusiveOption && cb.checked) {
				checkboxes.forEach(c => {
					if (c !== exclusiveOption) {
						c.checked = false;
					}
				});
				return;
			}

			if (cb !== exclusiveOption && cb.checked) {
				exclusiveOption.checked = false;
			}
		});
	});
}